import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useField } from 'formik'
import Inputs from 'components/Inputs'
import {
    selectSelectedCampaignSummary,
    selectRewriteCaptionReviewProgressUuids,
    setRewriteCaptionReviewProgressUuids,
    SubmissionProgressProps,
} from 'state/review'
import { selectCampaign } from 'state'
import TypewriterEffect from 'components/Submissions/Review/common/AiReview/TypewriterEffect'
import { TextAreaContainer } from 'particles/TextInputs/TextArea/style'
import RoundTag from 'particles/Tag'
import { useTheme } from 'particles/themes/styled'
import { useNewTranslation } from 'hooks/index'

interface TextAreaProps {
    submissionProgress: SubmissionProgressProps
    name: string
}

const TextArea: React.FC<TextAreaProps> = ({ submissionProgress, name }) => {
    const [newT] = useNewTranslation()
    const dispatch = useDispatch()
    const theme = useTheme()
    const [field] = useField(name)
    const campaignSummary = useSelector(selectSelectedCampaignSummary)
    const selectedCampaignUuid = campaignSummary?.uuid ?? ''
    const campaign = useSelector(selectCampaign(selectedCampaignUuid))
    const isAiCaptionReviewEnabled = campaign.brand.team?.is_ai_caption_review_enabled
    const rewriteProgressUuids = useSelector(selectRewriteCaptionReviewProgressUuids)
    const showWriterEffect = rewriteProgressUuids.includes(submissionProgress.uuid)
    const minTextAreaHeight = 120
    const maxTextAreaHeight = 332
    const typeFinishCallback = () => {
        const updateList = rewriteProgressUuids.filter(submissionUuid => submissionUuid != submissionProgress.uuid)
        dispatch(setRewriteCaptionReviewProgressUuids(updateList))
    }
    // TODO: wait for Nick to provide tag copy key
    const showTag =
        isAiCaptionReviewEnabled &&
        submissionProgress.data?.caption_review?.suggested_caption &&
        field?.value &&
        submissionProgress.data?.caption_review?.suggested_caption == field?.value
    return (
        <>
            {showTag && (
                <RoundTag
                    contentType="neutral"
                    customStyle={{
                        backgroundColor: theme.colors.surface.infoPastel,
                        color: theme.colors.text.info,
                        minWidth: '60px',
                    }}
                    label={newT('tag.aiSuggestedCaption')}
                />
            )}
            {showWriterEffect ? (
                <TextAreaContainer
                    minTextAreaHeight={minTextAreaHeight}
                    maxTextAreaHeight={maxTextAreaHeight}
                    className={'expanding-input text-area-container'}
                    size={'m'}
                >
                    <div className={'input-count-container'}>
                        <div className={'textarea-input-container'}>
                            <TypewriterEffect text={field?.value} typeFinishCallback={typeFinishCallback} />
                        </div>
                    </div>
                </TextAreaContainer>
            ) : (
                <Inputs.TextArea
                    className="expanding-input"
                    name="data.caption"
                    minTextAreaHeight={minTextAreaHeight}
                    maxTextAreaHeight={maxTextAreaHeight}
                />
            )}
        </>
    )
}

export default TextArea
